module.exports = __webpack_public_path__ + "img/tpc-38.4e8cb460.jpg";